import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  type: 'lookbook',
  aliases: ['lookbook'],
  path: 'Lookbook/LookbookTemplate.vue',
  slices: [{
    name: 'global_footer',
    path: 'Global/GlobalFooter.vue'
  }]
};